export function stringify(obj: any): string {
	return JSON.stringify(obj, (k, v) => v === undefined ? null : v);
}